/* RESPONSIBLE TEAM: team-ai-agent */
import Route from '@ember/routing/route';
import { ReactRoute } from 'embercom/lib/react-route';

class FinAiAgentEcommerceGetStartedRoute extends Route {
  reactEnabled() {
    return true;
  }
}

export default ReactRoute(FinAiAgentEcommerceGetStartedRoute, {
  overrideRenderTemplate: false,
});
